import React from 'react';
import './CreateButton.css';

const CreateButton = ({ label, onClick }) => (
    <button className="create-btn" onClick={onClick}>
        {label}
    </button>
);

export default CreateButton; 